import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", company_name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await register(f); toast.success("Workspace created!"); nav("/dashboard"); }
    catch (err) { toast.error(err.response?.data?.detail || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <Card className="w-full max-w-md p-8 border-slate-200 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 bg-emerald-600 rounded-xl flex items-center justify-center text-white">
            <Zap className="w-5 h-5" />
          </div>
          <div className="font-bold text-lg">WaggleAI</div>
        </div>
        <h2 className="text-2xl font-bold tracking-tight">Create your workspace</h2>
        <p className="text-sm text-slate-500 mt-1 mb-6">Start your free trial. No credit card required.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="name">Your name</Label>
            <Input id="name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required data-testid="register-name-input" />
          </div>
          <div>
            <Label htmlFor="company">Company / Workspace name</Label>
            <Input id="company" value={f.company_name} onChange={(e) => setF({ ...f, company_name: e.target.value })} required data-testid="register-company-input" />
          </div>
          <div>
            <Label htmlFor="email">Work email</Label>
            <Input id="email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="register-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" minLength={6} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="register-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="register-submit-button">
            {loading ? "Creating…" : "Create workspace"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-center text-slate-500">
          Already have an account? <Link to="/login" className="text-emerald-700 font-medium hover:underline" data-testid="login-link">Sign in</Link>
        </div>
      </Card>
    </div>
  );
}
